// extracted by mini-css-extract-plugin
module.exports = {"img":"card_img__vBoVs","meta":"card_meta__qCn8P","date":"card_date__3U0tn","title":"card_title__3tNT2"};